/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * The version of the OpenAPI document: 1.0.31
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SectionTypeEnum = 'text' | 'question';

export const SectionTypeEnum = {
    TEXT: 'text' as SectionTypeEnum,
    QUESTION: 'question' as SectionTypeEnum
};

